import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ADD_CREATE_QUESTION } from './constants';
import {
  AddCreateQuestionDataActionTypes,
  AddCreateQuestionError,
  AddCreateQuestionState,
  AddCreateQuestionSuccess,
} from './types';

const initialState: AddCreateQuestionState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: AddCreateQuestionDataActionTypes,
  ): AddCreateQuestionState => {
    switch (action.type) {
      case ADD_CREATE_QUESTION + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ADD_CREATE_QUESTION + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AddCreateQuestionSuccess).payload;
        break;
      }
      case ADD_CREATE_QUESTION + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AddCreateQuestionError).error;
        break;
      }
      case ADD_CREATE_QUESTION + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
